<template>
  <svg data-icon-name="instagram" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.871 25.5"><path d="M20.538.75h-15.2A4.59 4.59 0 0 0 .75 5.333v14.834a4.59 4.59 0 0 0 4.583 4.583h15.2a4.59 4.59 0 0 0 4.583-4.583V5.333A4.59 4.59 0 0 0 20.538.75zm-7.6 18.517c-2.636.002-5.014-1.585-6.024-4.02s-.454-5.239 1.41-7.104 4.667-2.423 7.103-1.415 4.024 3.385 4.024 6.021a6.52 6.52 0 0 1-6.512 6.517zM20.65 7.139c-.998 0-1.807-.809-1.807-1.807s.809-1.807 1.807-1.807 1.807.809 1.807 1.807c0 .479-.19.939-.529 1.278s-.798.529-1.278.529z" stroke="#000a12" stroke-miterlimit="10" stroke-width="1.5" fill="none"/></svg>
</template>

<script>
import {
  defineComponent,
} from 'vue';

export default defineComponent({});
</script>
